import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { AuthService } from '../services/auth.service';

@Injectable({
	providedIn: 'root'
})
export /**
 * This guard can be used to determine which landing page to use based on the app state 'isLoggedIn' value.
 * If the user is logged-in, the route is blocked and the router redirects to the clerk-search page or the agent dashboard page. 
 * If the user is not logged-in, we allow the route. (The assumption is that this will only be used on the '' base route.)
 */
class LandingPageGuardService implements CanActivate {
	constructor(private router: Router, private authService: AuthService) {}

	async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
		const isLoggedIn = this.authService.isLoggedIn();
		const userInfo = await this.authService.getUserInfo().toPromise();

		// If user is logged-in and NOT an insurance agent, go to the clerk search page
		if (isLoggedIn && !userInfo.isAgentUser) {
			this.router.navigate([ 'clerk' ]);
			return false;
		}
		// If user is logged-in and IS an insurance agent, go to the agent dashboard page
		else if(isLoggedIn && userInfo.isAgentUser){
			this.router.navigate([ 'agent' ]);
		}
		// Otherwise, allow the route
		else {
			this.router.navigate([ 'public' ]);
			return true;
		}
	}
}
